import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ContentWrapper from './ContentWrapper';
import { CustomTheme } from '../../appTemplates/MUIProviderTemplate/MUIProviderTemplateInterfaces';
import AppError from '../AppError/AppError';
import { appErrorSelector } from '../../store/selectors/appSelectors';

const useMainContentWrapperStyles = makeStyles((theme: CustomTheme) => ({
  mainContentWrapperClass: {
    marginBottom: '40px',
    [theme.breakpoints.up('xs')]: {
      marginTop: '80px',
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '60px',
    },
  },
  contentWrapperClass: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

interface IMainContentWrapper {
  children: React.ReactNode;
}

const MainContentWrapper: React.FC<IMainContentWrapper> = ({ children }) => {
  const appError = useSelector(appErrorSelector);
  const { mainContentWrapperClass, contentWrapperClass } = useMainContentWrapperStyles();

  return (
    <ContentWrapper className={mainContentWrapperClass}>
      {appError ? <AppError /> : children}
    </ContentWrapper>
  );
};

MainContentWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainContentWrapper;
